import { useQuery } from "@tanstack/react-query";
import { getWorkspaceImage } from "api/services/workspace-service";
import { getWorkspaceImageQueryKey } from "hooks/workspaceImage/queryKeys";

export const useGetWorkspaceImage = (workspaceId: string) => {
    const query = useQuery({
        queryKey: getWorkspaceImageQueryKey(workspaceId),
        queryFn: async (): Promise<Blob | null> => {
            const response = await getWorkspaceImage({ workspaceId });
            if (!response.success) {
                throw new Error("workspaceManagement.logo.previewError");
            }

            return response.data?.size ? response.data : null;
        },
        enabled: !!workspaceId,
        retry: false,
    });

    return {
        workspaceImage: query.data ?? null,
        workspaceImageLoading: query.isPending,
        workspaceImageLoaded: query.isSuccess,
        workspaceImageError: query.error,
        refetchWorkspaceImage: query.refetch,
    };
};
